import { lazy } from "react";
const Crosslink = lazy(() => import("./components/crosslink"));

export default {
  default: ({ ...props }) => <p>This widget is not implemented: {props?.type}</p>,
  crosslink: Crosslink
};
